<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import SectionCustomerGeneral from './SectionCustomerGeneral.vue'
import ModalCustomerDelete from './modals/ModalCustomerDelete.vue'
import ModalCustomerKidCreate from './modals/ModalCustomerKidCreate.vue'
import { useCustomerPrivileges } from '../model/customer-privileges.hook'
import { useCustomerDetailsApi } from '../api/details.hook'

defineOptions({
  name: 'CustomerOverviewPage',
})

const route = useRoute()
const { canViewCustomers } = useCustomerPrivileges()

// created_at / updated_at arrive pre-shifted into the admin's view timezone.
useOnTimezoneChange(() => {
  if (canViewCustomers.value) {
    void useCustomerDetailsApi({ customerId: route.params.id as string })
  }
})
</script>

<template>
  <SectionCustomerGeneral />
  <ModalCustomerDelete />
  <ModalCustomerKidCreate />
</template>
